module.exports = __webpack_public_path__ + "static/piavita-68a3f2c8a294c59323dcad3669e257b2.png";